import type {
  IToolbarItemConfigTiptap,
  IToolbarSettings,
  PublisherProvider,
  ToolbarButtonRenderers,
} from './../../../ricos-types';
import { TOOLBARS } from './../../../editor-common';

import type { Topics } from '../../topics';
import type { ToolbarServices } from '../../types';
import { formattingItemsRenderers } from '../formatting/formatting-renderers';
import { RicosToolbar } from '../ricos-toolbar';

export class StaticToolbar extends RicosToolbar<TOOLBARS.STATIC> {
  constructor(
    isMobile: boolean,
    services: ToolbarServices,
    publishers: PublisherProvider<Topics>,
    settings: IToolbarSettings<TOOLBARS.STATIC>,
    shouldCreate: boolean
  ) {
    super(isMobile, services, TOOLBARS.STATIC, publishers, settings);
    this.isEmpty = () => !shouldCreate;
  }

  getToolbarItemsConfig(options?: { disabled: boolean }): IToolbarItemConfigTiptap[] {
    return (
      this.services.plugins
        ?.getTextButtons()
        .toToolbarItemsConfig(
          this.type,
          this.isMobile,
          this.services.editor.getPublicCommands(),
          this.services.editor.adapter.tiptapEditor,
          options
        ) || []
    );
  }

  getToolbarItemsRenderers(
    _referenceElement?: HTMLElement | null | undefined
  ): ToolbarButtonRenderers {
    return formattingItemsRenderers;
  }
}
